module.exports = __webpack_public_path__ + "img/ai-meme.613d03d1.webp";